export class ColumnNamesValueConverter {
  toView(columnNames: string, i: number): string {
    return columnNames?.split(',')[i] ?? '';
  }
}
